import classnames from 'classnames';

import Button from 'components/buttons/button';
import Wysiwyg from 'components/content-blocks/partials/wysiwyg';
import FontIcon from 'components/icons';
import CustomCalendar from 'components/modal/custom-calendar';
import Signups from 'components/modal/signups';

import './styles/tippy-top-banner.scss';

type TippyTopBannerProps = {
    banner_text: string,
    button_link_url: string,
    button_text: string,
    button_type: string,
    enabled: boolean,
    style: string
}

export const TippyTopBanner = ({ enabled, style, banner_text, button_text, button_type, button_link_url }:TippyTopBannerProps) => {
  if (!enabled) {
    return null;
  }
  
  const renderButton = () => {
    switch (button_type) {
      case 'link':
        return (
          <Button
            className="tippy-top-details"
            type="link"
            href={ button_link_url }>
            {button_text}<FontIcon icon="arrow-right" />
          </Button>
        );
      case 'calendar':
        return (
          <CustomCalendar className="tippy-top-details" customCalendarUrl={ button_link_url } buttonModalLaunchText={ button_text } buttonArrow />
        );
      default:
        return (
          <Signups
            longPlaceholder={ true }
            showInitFields={ false }
            buttonClasses="tippy-top-details"
            showModalButton={ true }
            ctaVariation='modal'
            signupModalLaunch={ button_text }
            buttonArrow
          />
        );
    }
  };
  
  return (
    <section className={ classnames('tippy-top-banner-section', style) } data-section="tippy top banner">
      <div className="container">
        <Wysiwyg wysiwygClasses="tippy-top-text" content={ banner_text } />
        {renderButton()}
      </div>
    </section>);
};